function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1952(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.85,
    height: 7.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.5761538461538461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 3.745
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.49,
    width: 18.85,
    height: 16.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 15.915000000000001
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.34,
    width: 18.85,
    height: 18.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6785714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 33.715
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.1,
    width: 18.85,
    height: 23.15,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 54.675
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.25,
    width: 18.85,
    height: 23.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 78.045
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.84,
    width: 18.85,
    height: 24.34,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 102.01
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.18,
    width: 18.85,
    height: 24.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 126.59
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 139,
    width: 18.85,
    height: 26.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 152.025
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.05,
    width: 18.85,
    height: 33.03,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 181.565
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 198.07,
    width: 18.85,
    height: 33.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 214.98
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.89,
    width: 18.85,
    height: 37.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.692857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 250.85999999999999
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.83,
    width: 18.85,
    height: 38.5,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.692857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 289.08
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.33,
    width: 18.85,
    height: 38.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8850000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 327.68
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 347.03,
    width: 18.85,
    height: 40.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 367.15
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.27,
    width: 18.85,
    height: 42.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 408.41999999999996
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.57,
    width: 18.85,
    height: 43.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 451.235
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 472.9,
    width: 18.85,
    height: 43.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 494.765
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 516.63,
    width: 18.85,
    height: 44.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 538.655
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.68,
    width: 18.85,
    height: 44.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.692857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 583.02
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 605.36,
    width: 18.85,
    height: 45.99,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 628.355
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 651.35,
    width: 18.85,
    height: 48.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.425,
    y: 675.6750000000001
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 0,
    width: 28.14,
    height: 32.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.92,
    y: 16.465
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.98,
    y: 0,
    width: 28.84,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.4,
    y: 16.465
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.82,
    y: 0,
    width: 29.54,
    height: 32.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.58999999999999,
    y: 16.465
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.37,
    y: 0,
    width: 29.54,
    height: 32.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.14,
    y: 16.465
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.91,
    y: 0,
    width: 30.25,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.035,
    y: 16.465
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.16,
    y: 0,
    width: 30.81,
    height: 32.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.565,
    y: 16.465
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 0,
    width: 31.02,
    height: 32.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.48,
    y: 16.465
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.99,
    y: 0,
    width: 31.15,
    height: 32.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.565,
    y: 16.465
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.14,
    y: 0,
    width: 31.29,
    height: 32.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.91125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.78499999999997,
    y: 16.465
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.43,
    y: 0,
    width: 31.97,
    height: 32.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.567142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.415,
    y: 16.465
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 0,
    width: 32.24,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.52,
    y: 16.465
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.65,
    y: 0,
    width: 33.11,
    height: 32.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.205,
    y: 16.465
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.75,
    y: 0,
    width: 34.06,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.78,
    y: 16.465
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.81,
    y: 0,
    width: 34.31,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.96500000000003,
    y: 16.465
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.12,
    y: 0,
    width: 34.42,
    height: 32.93,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.33,
    y: 16.465
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.54,
    y: 0,
    width: 34.44,
    height: 32.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.76,
    y: 16.465
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.99,
    y: 0,
    width: 34.47,
    height: 32.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.225,
    y: 16.465
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.46,
    y: 0,
    width: 34.81,
    height: 32.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.865,
    y: 16.465
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 0,
    width: 34.81,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.665,
    y: 16.465
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.07,
    y: 0,
    width: 34.97,
    height: 32.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.5550000000001,
    y: 16.465
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 663.04,
    y: 0,
    width: 36.96,
    height: 32.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.658888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.52,
    y: 16.465
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 32.93,
    width: 35.94,
    height: 34.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 50.15
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 67.37,
    width: 35.94,
    height: 34.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.469
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 84.715
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 102.07,
    width: 35.94,
    height: 35.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5130000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 119.63499999999999
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 137.2,
    width: 35.94,
    height: 35.42,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 154.91
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 172.62,
    width: 35.94,
    height: 35.44,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.087999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 190.34
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 208.06,
    width: 35.94,
    height: 36.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.134285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 226.115
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 244.17,
    width: 35.94,
    height: 36.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.134285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 262.29499999999996
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 280.43,
    width: 35.94,
    height: 36.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 298.66
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 316.89,
    width: 35.94,
    height: 36.57,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 335.175
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 353.45,
    width: 35.94,
    height: 36.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 371.835
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 390.22,
    width: 35.94,
    height: 37.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 408.785
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 427.35,
    width: 35.94,
    height: 37.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 445.96500000000003
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 464.58,
    width: 35.94,
    height: 38.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 483.705
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 502.83,
    width: 35.94,
    height: 38.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.134285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 522.265
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 541.7,
    width: 35.94,
    height: 39.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 561.4050000000001
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 581.12,
    width: 35.94,
    height: 39.43,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 600.835
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 620.55,
    width: 35.94,
    height: 39.58,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 640.3399999999999
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.85,
    y: 660.13,
    width: 35.94,
    height: 39.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.82,
    y: 680.0649999999999
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 32.93,
    width: 36.25,
    height: 39.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.91499999999999,
    y: 52.78
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.04,
    y: 32.93,
    width: 36.26,
    height: 39.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.17,
    y: 52.78
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.3,
    y: 32.93,
    width: 36.81,
    height: 39.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.70499999999998,
    y: 52.78
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.11,
    y: 32.93,
    width: 36.9,
    height: 39.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.56,
    y: 52.78
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.01,
    y: 32.93,
    width: 36.98,
    height: 39.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.282857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.5,
    y: 52.78
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.99,
    y: 32.93,
    width: 37.28,
    height: 39.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.456
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.63,
    y: 52.78
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.27,
    y: 32.93,
    width: 37.3,
    height: 39.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.91999999999996,
    y: 52.78
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.57,
    y: 32.93,
    width: 37.37,
    height: 39.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.255,
    y: 52.78
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.95,
    y: 32.93,
    width: 37.47,
    height: 39.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.685,
    y: 52.78
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.42,
    y: 32.93,
    width: 37.77,
    height: 39.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.196666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.305,
    y: 52.78
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.19,
    y: 32.93,
    width: 38.54,
    height: 39.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.46,
    y: 52.78
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.73,
    y: 32.93,
    width: 38.67,
    height: 39.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.734
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.065,
    y: 52.78
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.4,
    y: 32.93,
    width: 39.37,
    height: 39.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.874
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.0849999999999,
    y: 52.78
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.77,
    y: 32.93,
    width: 39.41,
    height: 39.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.475,
    y: 52.78
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.18,
    y: 32.93,
    width: 39.5,
    height: 39.7,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.93,
    y: 52.78
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.68,
    y: 32.93,
    width: 39.61,
    height: 39.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.95125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.4849999999999,
    y: 52.78
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.29,
    y: 32.93,
    width: 39.71,
    height: 39.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.145,
    y: 52.78
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 72.63,
    width: 40.86,
    height: 38.84,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.548571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 92.05
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 111.48,
    width: 40.86,
    height: 39.36,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 131.16
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 150.83,
    width: 40.86,
    height: 39.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.641666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 170.75500000000002
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 190.68,
    width: 40.86,
    height: 40.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.511111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 210.98000000000002
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 231.28,
    width: 40.86,
    height: 41.62,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.837142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 252.09
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 272.9,
    width: 40.86,
    height: 44.44,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.172
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 295.12
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 317.34,
    width: 40.86,
    height: 45.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 340.155
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 362.97,
    width: 40.86,
    height: 46.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.837142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 386.295
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 409.62,
    width: 40.86,
    height: 47.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 433.36
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 457.1,
    width: 40.86,
    height: 47.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 480.90000000000003
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 504.7,
    width: 40.86,
    height: 48.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.837142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 528.84
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 552.98,
    width: 40.86,
    height: 48.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 577.36
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 601.74,
    width: 40.86,
    height: 49.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 626.275
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.79,
    y: 650.81,
    width: 40.86,
    height: 49.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.172
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.22,
    y: 675.405
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 72.63,
    width: 43.42,
    height: 46.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.236666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.36000000000001,
    y: 96.035
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.07,
    y: 72.63,
    width: 43.77,
    height: 46.81,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.95499999999998,
    y: 96.035
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.84,
    y: 72.63,
    width: 43.82,
    height: 46.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.75,
    y: 96.035
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.66,
    y: 72.63,
    width: 43.85,
    height: 46.81,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.264285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.585,
    y: 96.035
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 72.63,
    width: 44.08,
    height: 46.81,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.815999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.55,
    y: 96.035
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.59,
    y: 72.63,
    width: 46.17,
    height: 46.81,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.595714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.67499999999995,
    y: 96.035
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.76,
    y: 72.63,
    width: 46.41,
    height: 46.81,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.734999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.965,
    y: 96.035
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.16,
    y: 72.63,
    width: 46.9,
    height: 46.81,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.687142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.61,
    y: 96.035
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.06,
    y: 72.63,
    width: 46.93,
    height: 46.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.525,
    y: 96.035
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 72.63,
    width: 48.93,
    height: 46.81,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.362
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.465,
    y: 96.035
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.93,
    y: 72.63,
    width: 49.22,
    height: 46.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.54,
    y: 96.035
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.14,
    y: 72.63,
    width: 50.16,
    height: 46.81,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.362
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.22,
    y: 96.035
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.3,
    y: 72.63,
    width: 50.7,
    height: 46.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.681
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.65,
    y: 96.035
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 119.44,
    width: 48.45,
    height: 50.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.05625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 144.695
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 169.95,
    width: 48.45,
    height: 50.9,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.921428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 195.39999999999998
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 220.85,
    width: 48.45,
    height: 50.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.921428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 246.32
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 271.79,
    width: 48.45,
    height: 51.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.921428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 297.555
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 323.32,
    width: 48.45,
    height: 51.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.075000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 349.26
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 375.21,
    width: 48.45,
    height: 52.83,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.690000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 401.625
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 428.04,
    width: 48.45,
    height: 53.18,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 454.63
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 481.22,
    width: 48.45,
    height: 54.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.075000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 508.39000000000004
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 535.55,
    width: 48.45,
    height: 54.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.05625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 562.905
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 590.26,
    width: 48.45,
    height: 54.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.05625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 617.615
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 644.97,
    width: 48.45,
    height: 55.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.383333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.875,
    y: 672.485
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 119.44,
    width: 51.82,
    height: 51.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170,
    y: 145.26
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.92,
    y: 119.44,
    width: 52.06,
    height: 51.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.95,
    y: 145.26
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 119.44,
    width: 52.88,
    height: 51.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.41,
    y: 145.26
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.86,
    y: 119.44,
    width: 54.26,
    height: 51.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.99,
    y: 145.26
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.11,
    y: 119.44,
    width: 55.43,
    height: 51.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.825,
    y: 145.26
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.54,
    y: 119.44,
    width: 56.41,
    height: 51.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.745,
    y: 145.26
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.95,
    y: 119.44,
    width: 57.29,
    height: 51.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.59499999999997,
    y: 145.26
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.24,
    y: 119.44,
    width: 57.81,
    height: 51.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.145,
    y: 145.26
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.06,
    y: 119.44,
    width: 58.89,
    height: 51.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.505,
    y: 145.26
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.94,
    y: 119.44,
    width: 59.06,
    height: 51.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.164
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.47,
    y: 145.26
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 171.08,
    width: 57.5,
    height: 54.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 198.37
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 225.66,
    width: 57.5,
    height: 55.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 253.415
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 281.17,
    width: 57.5,
    height: 56.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.463333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 309.56
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 337.96,
    width: 57.5,
    height: 57.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.334444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 366.465
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 394.96,
    width: 57.5,
    height: 58.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 424.09999999999997
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 453.24,
    width: 57.5,
    height: 58.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 482.40500000000003
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 511.57,
    width: 57.5,
    height: 58.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.214285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 540.99
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 570.41,
    width: 57.5,
    height: 62.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 601.7049999999999
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.09,
    y: 633,
    width: 57.5,
    height: 67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.84,
    y: 666.5
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 171.08,
    width: 56.19,
    height: 70.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.695,
    y: 206.235
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.79,
    y: 171.08,
    width: 56.58,
    height: 70.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.082857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.08000000000004,
    y: 206.235
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.37,
    y: 171.08,
    width: 61.06,
    height: 70.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.9,
    y: 206.235
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.43,
    y: 171.08,
    width: 62.94,
    height: 70.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.9,
    y: 206.235
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.37,
    y: 171.08,
    width: 63,
    height: 70.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.87,
    y: 206.235
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.37,
    y: 171.08,
    width: 64.26,
    height: 70.31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.180000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.5,
    y: 206.235
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.63,
    y: 171.08,
    width: 66.35,
    height: 70.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.058333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.805,
    y: 206.235
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.98,
    y: 171.08,
    width: 68.02,
    height: 70.31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.717142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.99,
    y: 206.235
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 241.4,
    width: 68,
    height: 71.34,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 277.07
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 312.73,
    width: 68,
    height: 71.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 348.69
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 384.65,
    width: 68,
    height: 76.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 422.945
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 461.24,
    width: 68,
    height: 77.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 499.925
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 538.61,
    width: 68,
    height: 79.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 578.345
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 618.07,
    width: 68,
    height: 81.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.6,
    y: 659.0350000000001
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 241.4,
    width: 65.45,
    height: 90.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.32500000000005,
    y: 286.87
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.05,
    y: 241.4,
    width: 66.1,
    height: 90.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.1,
    y: 286.87
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.15,
    y: 241.4,
    width: 74.09,
    height: 90.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.818000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.195,
    y: 286.87
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.24,
    y: 241.4,
    width: 106.89,
    height: 90.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.6850000000001,
    y: 286.87
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.13,
    y: 241.4,
    width: 117.87,
    height: 90.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.065,
    y: 286.87
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 332.33,
    width: 117.41,
    height: 114.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.26375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.305,
    y: 389.385
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 446.45,
    width: 117.41,
    height: 121.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.67625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.305,
    y: 507.015
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.6,
    y: 567.58,
    width: 117.41,
    height: 132.42,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.305,
    y: 633.7900000000001
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 332.33,
    width: 141.05,
    height: 158.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.150000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.53499999999997,
    y: 411.53499999999997
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.05,
    y: 332.33,
    width: 171.95,
    height: 158.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.025,
    y: 411.53499999999997
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 490.74,
    width: 312.99,
    height: 209.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.876666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.505,
    y: 595.37
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1952);
export default __webpack_public_path__ + "static/media/1952.fc5a7f2857421e99aa713ca8428f160b.svg";
export { ForwardRef as ReactComponent };